<script lang="ts">

      async function handleClick(ev: MouseEvent) {
        return
      }
  

      let { onclick = handleClick, variant = 'primary', size = 'normal', type = "link", href = "#", newTab = true, children, class: className = "" } = $props()
</script>

{#if type == "link"}
<a href="{href}" class="button rounded-full text-nowrap {className} {variant} {size}" target={newTab ? '_blank' : '_self'}>{@render children?.()}</a>
{/if}

{#if type == "button"}
<button {onclick} class="button rounded-full {variant} {size}">{@render children?.()}</button>
{/if}

<style lang="postcss">
      .button:global(.secondary) {
            @apply bg-[var(--df-slate)] active:bg-[var(--df-primary)];
      }

      .button:global(.primary) {
            @apply active:bg-[var(--df-slate)] bg-[var(--df-primary)];
      }

      .button:global(.custom) {
            @apply px-6 py-2 font-[300];
      }
      .button:global(.disabled) {
            @apply bg-[var(--df-slate)] cursor-default;
      }

      .button:global(.normal) {
            @apply text-xl px-6 py-2 font-[300];
      }

      .button:global(.bigger) {
            @apply text-3xl px-8 py-4 font-[300];
      }

      .button:global(.biggest) {
            @apply text-4xl px-8 py-4 font-[300];
      }
</style>
